import "../components/Cta.css";

const CTA = () => {
  return (
    <section className="cta-section d-flex align-items-center text-center text-white">
      <div className="container">
        <h2 className="cta-title mb-3">
          Ready To Start Your Project?
        </h2>

        <p className="cta-subtitle mb-4">
          Let’s build something amazing together with Code Inputs.
        </p>

        <a href="#contact" className="cta-btn">
          Contact Us
        </a><br/><br/>

        <a href="https://www.google.com/maps/place/CodeInputs/@19.7291131,61.000837,4z/data=!4m8!3m7!1s0x8b0e2c50dc6488d3:0xfcda6f91bedf7bb8!8m2!3d21.0680074!4d82.7525294!9m1!1b1!16s%2Fg%2F11mct2pmml?authuser=0&entry=ttu&g_ep=EgoyMDI2MDMxOC4xIKXMDSoASAFQAw%3D%3D" className="cta-btn">
          View Our Google Reviews
        </a>
      </div>
    </section>
  );
};

export default CTA;
